export const WarningMessageConfiguration = {
    AdditionalFormFields: {
        MissingValues: {
            Title: process.env.REACT_APP_NO_MISSING_VALUES_TITLE?.toString() ?? "Warning!",
            Content: process.env.REACT_APP_MISSING_VALUES_CONTENT?.toString() ?? "Please enter the required values"
        }
    }
}